import { Link } from 'react-router-dom'

import { Avatar, Box, EnhancedDimension } from '@factorialco/deprecated-design-system'
import {
  EmployeesEmployeeAvatarFragment,
  EmployeesEmployeeNameAvatarFragment,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'

import { EmployeeQuickView, EmployeeQuickViewProps } from '../EmployeeQuickView'

const variants = ['small', 'medium', 'large'] as const
type Variant = (typeof variants)[number]

const sizes: Record<Variant, EnhancedDimension> = {
  small: 's24',
  medium: 's32',
  large: 's48',
}

type Props = {
  employee: EmployeesEmployeeAvatarFragment | EmployeesEmployeeNameAvatarFragment
  linkProfile?: boolean
  variant?: Variant
  disableQuickView?: boolean
  usePreferredName?: boolean
} & EmployeeQuickViewProps

export const EmployeeAvatar: React.FC<Props> = (props) => {
  const {
    employee,
    variant = 'medium',
    linkProfile,
    disableQuickView,
    usePreferredName,
    ...quickViewProps
  } = props
  const { navigation } = useNavigation()

  const preferredName = employee.preferredName || employee.access.fullName
  const displayedName = usePreferredName ? preferredName : employee.access.fullName
  const avatar = (
    <Avatar label={displayedName} url={buildUrl(employee.access?.avatar)} size={sizes[variant]} />
  )

  return (
    <Box inline>
      <EmployeeQuickView enabled={!disableQuickView} employee={employee} {...quickViewProps}>
        {linkProfile ? (
          <Link
            onClick={quickViewProps.onViewProfile}
            to={navigation.employees.id.fullPath({ id: employee.id })}
            style={{ display: 'block' }}
          >
            {avatar}
          </Link>
        ) : (
          <span>{avatar}</span>
        )}
      </EmployeeQuickView>
    </Box>
  )
}
